import { useMutation } from '@tanstack/react-query';

import { REPORTING_LE_LENS_FILTER_PATH } from '~/consts/reportingLeLensApi';

import { request } from '~/services/common';

import { resolveReportingLeLensUrl } from '~/utils/resolveReportingLeLensUrl';

import { encodedJsonBody } from './encodedJsonBody';

export type LensFilterTargetInput = {
  key: string;
  label: string;
  options: ReadonlyArray<string>;
  multiple?: boolean;
};

export type LensFilterPeriodResponse =
  | { kind: 'preset'; preset: 'lensDefault' | 'last7CompletedDays' | 'last30CompletedDays' | 'yearToDate' }
  | { kind: 'fixed'; from: string; to: string };

export type InterpretLensFiltersResponse =
  | {
      kind: 'ready';
      proposal: {
        changes: Array<string>;
        period?: LensFilterPeriodResponse;
        comparison?: 'previousYear' | 'previousPeriod' | null;
        values?: Record<string, Array<string>>;
        clearValues?: boolean;
      };
    }
  | { kind: 'error'; message: string; reason?: 'model_unavailable' };

export function useInterpretLensFilters() {
  return useMutation({
    mutationFn: async ({
      query,
      targets,
      allowPeriod = true,
    }: {
      query: string;
      targets: ReadonlyArray<LensFilterTargetInput>;
      allowPeriod?: boolean;
    }) =>
      (await request(resolveReportingLeLensUrl(REPORTING_LE_LENS_FILTER_PATH), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: encodedJsonBody({
          query,
          allowPeriod,
          targets: targets.map(({ key, label, options, multiple }) => ({ key, label, options, multiple })),
        }),
      })) as InterpretLensFiltersResponse,
    retry: false,
  });
}
